import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { FormControlLabel, Checkbox } from '@mui/material';
import { Asset } from '../../../../store/Asset';
import { RpmAccount } from '../../../../store/RpmAccount';
import { ProvisionalAsset } from '../../../../store/ProvisionalAsset';
import { camelToKebab } from '../../../../utils/helpers';
import { TextBlock, TextSpan } from '../../../Atoms/Text';
import { ICON_MAP_MD } from '../../Drawer/Drawer';
import { Icon } from '../../../Atoms/Icon';
import { FormData } from './TicketFormFields';

interface LinkedReferenceProps {
  objectType: 'asset' | 'provisionalAsset' | 'rpmAccount' | 'customer';
  objectLinkId?: string;
  objectLinkDisplay?: string;
  isSubmitting: boolean;
  formData: FormData;
  setFormData: (data: FormData) => void;
  handleClose: () => void;
  otherRpmAssociations: RpmAccount[];
  otherAssetAssociations: Asset[];
  otherPAAssociations: ProvisionalAsset[];
}

export const LinkedReference = ({
  objectType,
  objectLinkId,
  objectLinkDisplay,
  isSubmitting,
  formData,
  setFormData,
  handleClose,
  otherRpmAssociations,
  otherAssetAssociations,
  otherPAAssociations
}: LinkedReferenceProps) => {
  const getLinkedObjectsCount = () => {
    switch (objectType) {
      case 'asset':
      case 'provisionalAsset':
        return otherRpmAssociations.length;
      case 'rpmAccount':
        return otherAssetAssociations.length + otherPAAssociations.length;
      default:
        return 0;
    }
  };

  const getLinkedObjectsLabel = () => {
    switch (objectType) {
      case 'rpmAccount':
        return 'Also reference linked Assets and PAs';
      default:
        return 'Also reference linked RPM Accounts';
    }
  };

  return (
    <Fragment>
      <div className="justify-center">
        <TextBlock
          color="grey6"
          size="sm">
          Reference
        </TextBlock>
        <TextSpan className="flex items-center space-x-2">
          <Icon
            className="p-3"
            type={ICON_MAP_MD[objectType] || ''}
          />
          <Link
            onClick={(e) => {
              if (e.metaKey || e.ctrlKey) {
                e.stopPropagation();
              } else {
                handleClose();
              }
            }}
            className="text-indigo"
            aria-disabled={isSubmitting}
            to={`/${camelToKebab(objectType)}/${objectLinkId}`}>
            {objectLinkDisplay}
          </Link>
        </TextSpan>
      </div>
      {getLinkedObjectsCount() > 0 && (
        <div className="justify-center">
          <FormControlLabel
            disabled={isSubmitting}
            control={
              <Checkbox
                checked={formData.referenceLinkedObjects}
                onChange={() => setFormData({ ...formData, referenceLinkedObjects: !formData.referenceLinkedObjects })}
              />
            }
            label={
              <TextBlock
                color="grey6"
                size="sm">
                {getLinkedObjectsLabel()}
              </TextBlock>
            }
          />
        </div>
      )}
    </Fragment>
  );
};
